
<div class="internalMax_Custom">
  <form [formGroup]="internalMaxForm" class="internalMax" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-sm-6 form-group">

        <!--Username Region-->
        <mat-form-field appearance="outline">
          <mat-label> UserName </mat-label>
          <input matInput formControlName="userName" required (keyup)="changeEmail($event)">
          <mat-spinner #spinner matSuffix [diameter]="18" style="float: right; margin-left: 8px; visibility:hidden"></mat-spinner>
        </mat-form-field>
        @if (
          internalMaxForm.get('userName')?.invalid &&
          (internalMaxForm.get('userName')?.dirty ||
          internalMaxForm.get('userName')?.touched)) {
          <p class="p-max-height">
            @if (internalMaxForm.get('userName')?.hasError('required')) {
              <mat-error>This field is required</mat-error>
            }
            @if (internalMaxForm.get('userName')?.hasError('alphanumericError')) {
              <mat-error>
                {{internalMaxForm.get('userName') ? internalMaxForm['userName']?.errors['alphanumericError'] : ''}}
              </mat-error>
            }
            @if (internalMaxForm.get('userName')?.hasError('maxlength')) {
              <mat-error>Max {{ limits.MailNickname }} characters</mat-error>
            }
          </p>
        }
        <p igIf="emailError" class="p-max-height">
          <mat-error>{{emailError}}</mat-error>
        </p>
        @if (!(
          internalMaxForm.get('userName')?.invalid &&
          (internalMaxForm.get('userName')?.dirty ||
          internalMaxForm.get('userName')?.touched)) && !emailError) {
          <p><br> </p>
        }

      </div>
      <div class="col-sm-6 form-group">
        <br />
        <p>{{domain}}</p>
      </div>

    </div>

    <div class="row">
      <div class="col-sm-6 form-group">

        <mat-form-field appearance="outline">
          <mat-label> First Name </mat-label>
          <input matInput formControlName="firstName" required>
        </mat-form-field>
        @if (
          internalMaxForm.get('firstName')?.invalid &&
          (internalMaxForm.get('firstName')?.dirty ||
          internalMaxForm.get('firstName')?.touched)) {
          <p class="p-max-height">
            @if (internalMaxForm.get('firstName')?.hasError('required')) {
              <mat-error>This field is required</mat-error>
            }
            @if (internalMaxForm.get('firstName')?.hasError('maxlength')) {
              <mat-error>Max {{ limits.GivenName }} characters</mat-error>
            }
          </p>
        }
        @if (!(
          internalMaxForm.get('firstName')?.invalid &&
          (internalMaxForm.get('firstName')?.dirty ||
          internalMaxForm.get('firstName')?.touched))) {
          <p><br> </p>
        }

      </div>
      <div class="col-sm-6 form-group">

        <mat-form-field appearance="outline">
          <mat-label> Last Name </mat-label>
          <input matInput formControlName="lastName" required>
        </mat-form-field>
        @if (
          internalMaxForm.get('lastName')?.invalid &&
          (internalMaxForm.get('lastName')?.dirty ||
          internalMaxForm.get('lastName')?.touched)) {
          <p class="p-max-height">
            @if (internalMaxForm.get('lastName')?.hasError('required')) {
              <mat-error>This field is required</mat-error>
            }
            @if (internalMaxForm.get('lastName')?.hasError('maxlength')) {
              <mat-error>Max {{ limits.Surname }} characters</mat-error>
            }
          </p>
        }
        @if (!(
          internalMaxForm.get('lastName')?.invalid &&
          (internalMaxForm.get('lastName')?.dirty ||
          internalMaxForm.get('lastName')?.touched))) {
          <p><br> </p>
        }
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-sm-12 form-group">

        <!--Displayname Region-->
        <mat-form-field appearance="outline">
          <mat-label> Display Name </mat-label>
          <input matInput formControlName="displayName" required>
        </mat-form-field>
        @if (
          internalMaxForm.get('displayName')?.invalid &&
          (internalMaxForm.get('displayName')?.dirty ||
          internalMaxForm.get('displayName')?.touched)) {
          <p class="p-max-height">
            @if (internalMaxForm.get('displayName')?.hasError('required')) {
              <mat-error>This field is required</mat-error>
            }
            @if (internalMaxForm.get('displayName')?.hasError('maxlength')) {
              <mat-error>Max {{ limits.DisplayName }} characters</mat-error>
            }
          </p>
        }
        @if (!(
          internalMaxForm.get('displayName')?.invalid &&
          (internalMaxForm.get('displayName')?.dirty ||
          internalMaxForm.get('displayName')?.touched))) {
          <p><br> </p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 form-group">


        <!--Password Region-->
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" required [type]="passHide ? 'password' : 'text'">
            <button mat-icon-button matSuffix (click)="passHideFunc($event)" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passHide">
              <mat-icon>{{passHide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <button mat-icon-button matSuffix (click)="genPass($event)">
              <mat-icon>settings_suggest</mat-icon>
            </button>
          </mat-form-field>

          @if (
            internalMaxForm.get('password')?.invalid &&
            (internalMaxForm.get('password')?.dirty ||
            internalMaxForm.get('password')?.touched)) {
            <p class="p-max-height">
              @if (internalMaxForm.get('password')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
              @if (internalMaxForm.get('password')?.hasError('passwordStrength')) {
                <mat-error>
                  {{internalMaxForm.get('password') ? internalMaxForm['password']?.errors['passwordStrength'] : ''}}
                </mat-error>
              }
              @if (internalMaxForm.get('password')?.hasError('passwordContained')) {
                <mat-error>
                  Password cannot be contained in UserName
                </mat-error>
              }
              @if (internalMaxForm.get('password')?.hasError('maxlength')) {
                <mat-error>Max {{ limits.PasswordMax }} characters</mat-error>
              }
            </p>
          }
          @if (!(
            internalMaxForm.get('password')?.invalid &&
            (internalMaxForm.get('password')?.dirty ||
            internalMaxForm.get('password')?.touched))) {
            <p><br> </p>
          }
        </div>


      </div>
      <div class="col-sm-6 form-group">

        <!--Confirm Password Region-->
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="confirmPassword" required [type]="confirmPassHide ? 'password' : 'text'">
            <button mat-icon-button matSuffix (click)="handleConfirmPass($event)" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="confirmPassHide">
              <mat-icon>{{confirmPassHide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>


          @if (
            internalMaxForm.get('confirmPassword')?.invalid &&
            (internalMaxForm.get('confirmPassword')?.dirty ||
            internalMaxForm.get('confirmPassword')?.touched)) {
            <p class="p-max-height">
              @if (internalMaxForm.get('confirmPassword')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
              @if (internalMaxForm.get('confirmPassword')?.hasError('confirmPasswordValidator')) {
                <mat-error>
                  Confirm Password is not same
                </mat-error>
              }
            </p>
          }
          @if (!(
            internalMaxForm.get('confirmPassword')?.invalid &&
            (internalMaxForm.get('confirmPassword')?.dirty ||
            internalMaxForm.get('confirmPassword')?.touched))) {
            <p><br> </p>
          }
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 form-group">

        <p class="darkBackground"><mat-checkbox formControlName="boolPassChange">Must change password next login</mat-checkbox></p>
        <p class="darkBackground"><mat-checkbox formControlName="IsSubcontractorUser">Subcontractor user</mat-checkbox></p>

      </div>
    </div>

    <div class="row">
      <div class="col-sm-4 form-group">
        <br />
        <mat-label> <span>Tenant</span><span class="orange-asterisk"> *</span></mat-label>


      </div>
      <div class="col-sm-8 form-group">

        <!--Primary Tenant Drop Down-->
        <ng-select [items]="tenants"
          [searchable]="true"
          [clearable]="false"
          class="tenantStyling"
          bindLabel="text"
          bindValue="value"
          formControlName="tenant"
          appendTo="body"
          required>
        </ng-select>

        <br>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 form-group">
          <br />
          <mat-label>Secondary Tenant</mat-label>


        </div>
        <div class="col-sm-8 form-group">

          <!--Secondary Tenant Drop Down-->
          <ng-select (change)="onSecTenChange()"
            [matTooltip]="selectedSecTenString"
            [matTooltipPosition]="'above'"
            [items]="secondaryTenants"
            groupBy="selectedAllGroup"
            [selectableGroup]="true"
            [selectableGroupAsModel]="false"
            [searchable]="true"
            [clearable]="true"
            [closeOnSelect]="false"
            [multiple]="true"
            bindLabel="text"
            bindValue="value"
            formControlName="secondaryTenant"
            class="tenantStyling"
            appendTo="body">

            <ng-template ng-optgroup-tmp>
              Select All
            </ng-template>

            <ng-template ng-option-tmp
              let-item="item">
              {{ item.text }}
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              @if (this.internalMaxForm.controls['secondaryTenant'].value.length <= 2) {
                <div class="items-selected">
                  @for (item of this.internalMaxForm.controls['secondaryTenant'].value ; track item) {
                    <div class="ng-value">
                      <span class="ng-value-label">{{item}}</span>
                    </div>
                  }
                </div>
              }

              @if (items.length > 2) {
                <div class="ng-value">
                  <span class="ng-value-label">{{items.length}} Selected...</span>
                </div>
              }

            </ng-template>

          </ng-select>
          <br>

          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 form-group">
            <br />
            <mat-label>Email</mat-label>


          </div>
          <div class="col-sm-8 form-group">

            <!--Email Region-->
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput placeholder="pat@example.com" formControlName="email">
              </mat-form-field>

              @if (
                internalMaxForm.get('email')?.invalid &&
                (internalMaxForm.get('email')?.dirty ||
                internalMaxForm.get('email')?.touched)) {
                <p>
                  <!--<mat-error *ngIf="internalMaxForm.get('email').hasError('required')">This field is required</mat-error>-->
                  @if (internalMaxForm.get('email')?.hasError('pattern') || internalMaxForm.get('email')?.hasError('email')) {
                    <mat-error>
                      Enter valid email
                    </mat-error>
                  }
                  @if (internalMaxForm.get('email')?.hasError('maxlength')) {
                    <mat-error>Max {{ limits.Mail }} characters</mat-error>
                  }
                </p>
              }
              @if (!(
                internalMaxForm.get('email')?.invalid &&
                (internalMaxForm.get('email')?.dirty ||
                internalMaxForm.get('email')?.touched))) {
                <p><br> </p>
              }
            </div>

          </div>
        </div>


        <div class="row">
          <div class="panel-body">
            <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-red ">
              <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
              Back
            </button>

            <button mat-raised-button type="submit" class="btn button-fix button-color-fix-orange pull-right" [disabled]="!internalMaxForm.valid || emailError || waiting4Mail">
              Create
              <mat-icon class=" icon-color-fix ">person</mat-icon>
            </button>

          </div>
        </div>

      </form>
    </div>
